import React from 'react';

export const DOCUMENT_NAMES = [
  <>Обмерный план</>,
  <>Планировочное решение с&nbsp;расстановкой мебели и&nbsp;оборудования</>,
  <>План демонтажа</>,
  <>Монтажный план</>,
  <>План привязки точек подключения инженерных коммуникаций</>,
  <>План привязки электрооборудования</>,
  <>План привязки светильников</>,
  <>План отделки потолков</>,
  <>План отделки полов</>,
  <>Схема отделки помещения</>,
  <>Развёртки по&nbsp;стенам</>,
  <>План привязки сантехнического оборудования</>,
  <>Схема мебели индивидуального изготовления</>,
  <>Спецификация мебели и&nbsp;оборудования</>,
];
